<script>
import FilePreview from '@/utils/FilePreview.vue'
export default {
    name: 'EkDialog',
    props: {
        url: {
            type: String,
            required: true
        }
    },
    components: {
        FilePreview
    },
    methods: {
        closeDialog() {
            this.$emit('close', null)
        }
    }
}
</script>

<template>
    <div class="preview-dialog-box" id="preview-dialog-box">
        <div class="close-btn" @click.stop="closeDialog">
            <i class="el-icon-close"></i>
        </div>
        <div class="dialog-body">
            <file-preview :url="url" />
        </div>
    </div>
</template>

<style scoped lang="scss">
.preview-dialog-box {
    &:hover {
        .close-btn {
            display: flex;
        }
    }
    &,
    & * {
        box-sizing: border-box;
    }
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1000;
    .dialog-body {
        width: 100%;
        height: 100%;
    }
    .close-btn {
        cursor: pointer;
        position: absolute;
        top: 20px;
        right: 20px;
        background: rgba(96, 98, 102, 0.5);
        width: 40px;
        height: 40px;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        i {
            font-size: 20px;
            color: #fff;
        }
        z-index: 1001;
    }
}
</style>
